// src/pages/Dashboard/Finance/Payroll/OverallIncome.jsx
import React from "react";
import { Grid, Paper, Box, Typography, useMediaQuery } from "@mui/material";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const OverallIncome = ({ appointmentData = {}, labData = {}, radiologyData = {} }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const data = [
    {
      name: t("finance.appointments"),
      value: Number(appointmentData.total_revenue_from_appointments) || 0,
    },
    { name: t("finance.labRevenue"), value: Number(labData.total_lab_revenue) || 0 },
    { name: t("finance.xrayRevenue"), value: Number(radiologyData.xray_revenue) || 0 },
    { name: t("finance.ultRevenue"), value: Number(radiologyData.ultrasound_revenue) || 0 },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.incomeOverview")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={isSmallScreen ? 250 : 300}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={isSmallScreen ? 50 : 70}
              outerRadius={isSmallScreen ? 90 : 120}
              fill="#8884d8"
              label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={["#8884d8", "#82ca9d", "#ffc658", "#a4de6c"][index % 4]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout={isSmallScreen ? "horizontal" : "vertical"}
              verticalAlign={isSmallScreen ? "bottom" : "middle"}
              align="center"
            />
          </PieChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default OverallIncome;
